export const config = {
  title: 'MSOR PAINTING LLC | Professional Painting Services in Reading, PA & Hammonton, NJ',
  meta: {
    description:
      'MSOR PAINTING LLC is your trusted painting company serving Reading, PA and Hammonton, NJ. We provide top-quality residential and commercial painting, pressure washing, and drywall repair services.',
    keywords: [
      'MSOR PAINTING LLC',
      'Painting Services',
      'Residential Painting',
      'Commercial Painting',
      'Interior Painting',
      'Exterior Painting',
      'Drywall Repair',
      'Pressure Washing',
      'Reading PA Painters',
      'Hammonton NJ Painters',
    ],
    author: 'MSOR PAINTING LLC',
    canonicalUrl: 'https://www.msorpaintingllc.com/',
  },
  sections: {
    header: {
      businessName: 'MSOR PAINTING LLC',
    },
    sectionB: {
      heroTitle: 'MSOR PAINTING LLC',
      heroSubtitle: 'Quality Painting Services in Reading, PA & Hammonton, NJ',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '6098806436',
      phoneLabel: '(609) 880-6436',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1312114883/photo/mature-painter-painting-a-wall.jpg?s=612x612&w=0&k=20&c=t-afZ_AqE2YBkVrpc2VxAGtFfXpySDYrCOgLznO5cTk=',
      cardData: [
        {
          title: 'Residential & Commercial Painting',
          description:
            'We provide high-quality painting services for both homes and commercial properties—interior and exterior.',
        },
        {
          title: 'Drywall & Repair Work',
          description:
            'From patching holes to full drywall replacement, we handle all surface preparation before painting.',
        },
        {
          title: 'Power Washing & Surface Cleaning',
          description:
            'Enhance curb appeal and prepare surfaces with professional pressure washing services.',
        },
      ],
      description:
        'MSOR PAINTING LLC proudly serves Reading, PA and Hammonton, NJ with professional painting, drywall repair, and pressure washing services. We’re committed to delivering clean finishes, timely service, and complete satisfaction for every project.',
    },
    sectionC: {
      servicesTitle: 'Our Painting Services',
      servicesDescription:
        'We specialize in top-tier painting services that transform your space with precision and care.',
      cards: [
        {
          title: 'Interior Painting',
          description:
            'Transform any room with smooth, vibrant interior painting finishes customized to your vision.',
          imageSrc: 'https://media.istockphoto.com/id/1221306297/photo/man-pours-paint-into-the-tray-and-dips-roller-professional-interior-construction-worker.jpg?s=612x612&w=0&k=20&c=PWolPdRCdlqy3mouV7lLB2-CHEUNzKHNRPrKXW4UR44=',
          imageAlt: 'Interior Painting Service',
        },
        {
          title: 'Exterior Painting',
          description:
            'Boost your curb appeal with durable, weather-resistant exterior paint jobs.',
          imageSrc: 'https://media.istockphoto.com/id/856887906/photo/house-painter-painting-building-exterior-with-roller.jpg?s=612x612&w=0&k=20&c=o4PGUAr27V9wKqqrTF9ZcB_fAeDkk-qAjeOiXaaSxjE=',
          imageAlt: 'Exterior Painting Service',
        },
        {
          title: 'Drywall & Repair',
          description:
            'We expertly repair drywall damage and prep your surfaces for a flawless paint finish.',
          imageSrc: 'https://media.istockphoto.com/id/1501174742/photo/close-up-of-female-hands-remove-masking-tape.jpg?s=612x612&w=0&k=20&c=zdDXfGQi2ZgYMy-INtaW0dFrKsdwFMqyJbp9uLeFHkQ=',
          imageAlt: 'Drywall Repair',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Power Washing',
        'Deck & Fence Painting',
        'Cabinet Painting',
        'Stucco Painting',
        'Paint Color Consultation',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1180625968/photo/process-of-painting-wall-with-green-color-paintbrush-close-up-diy-house-improvement-project.jpg?s=612x612&w=0&k=20&c=70l8PP-LGAMSgh3PMHX9sflGj5zvIiDvWm8hABQ2Yho=',
        alt: 'MSOR PAINTING LLC Team',
      },
      aboutText: [
        'MSOR PAINTING LLC is a family-owned painting company with locations in Reading, PA and Hammonton, NJ.',
        'We are passionate about delivering excellence and treating every home and commercial property with the utmost care and respect. Our experienced crew is known for attention to detail, clean workspaces, and reliable timelines.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'MSOR PAINTING LLC Logo',
      businessName: 'MSOR PAINTING LLC',
      contact: {
        phone: '6098806436',
        phoneLabel: '(609) 880-6436',
        email: 'vasquezoliva@yahoo.com',
        website: 'https://www.msorpaintingllc.com/',
        address: 'Hammonton, NJ, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Hammonton, NJ, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3106.870352497258!2d-74.74352208458274!3d39.63622307945809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c11dd58be9d7e5%3A0x9962f27f91db2de9!2sHammonton%2C%20NJ%2008037%2C%20USA!5e0!3m2!1sen!2sus!4v1712100000000!5m2!1sen!2sus',
    },
  },
};

export default config;
